import { render, staticRenderFns } from "./foundation.vue?vue&type=template&id=0a6048b8&"
import script from "./foundation.vue?vue&type=script&lang=js&"
export * from "./foundation.vue?vue&type=script&lang=js&"
import style0 from "./foundation.vue?vue&type=style&index=0&id=0a6048b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports